import {
  WSActions,
  WSElement,
  WSList,
  WSPanel,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  PGLIEnrollmentFeesInfoBox,
  PGLIManagingYourPolicy
} from "../../../components/customBenefits/PGLI";
import React from "react";
import { FilingAClaim } from "../../../components/FilingAClaim";
import { PGLI_KEY } from "../../../utils/constants";
import { FlowStep } from "../../../../../shared/components/FlowSwitch/types";

export const StepHowItWorks: React.FC<FlowStep> = props => {
  return (
    <WSPanel>
      <WSList gap="2XL">
        <WSElement>
          <WSText.Paragraph weight="medium" mb="XL">
            How the insurance works
          </WSText.Paragraph>
          <WSText.ParagraphSm color="gray500" mb="L">
            Enrolling is fast and coverage begins immediately. Premiums are
            automatically managed through the Wingspan platform.
          </WSText.ParagraphSm>
          <WSList gap="S" mb="L">
            <PGLIEnrollmentFeesInfoBox theme="neutral" />
            <PGLIManagingYourPolicy />
            <FilingAClaim planType={PGLI_KEY} />
          </WSList>
        </WSElement>

        <WSActions
          alignment="fill"
          buttons={[
            {
              kind: "Tertiary",
              onClick: props.onBack,
              label: "Back"
            },
            {
              label: "Continue",
              type: "submit",
              onClick: props.onNext
            }
          ]}
        />
      </WSList>
    </WSPanel>
  );
};
